import type { Keystroke } from "./keystroke";

/**
 * 複数キーにまたがるコマンドの待機状態。
 * `g`: `gg` の2打目待ち。`find-char`: `f`/`t` の対象文字待ち。
 * `text-object`: `i`/`a` の後のオブジェクト文字待ち（オペレータ経由のみ）。
 * `register-name`: `"` の後のレジスタ名待ち。
 * `mark-set` / `mark-jump`: `m` / `` ` `` の後のマーク名待ち。
 * `macro-record-name` / `macro-play-name`: `q` / `@` の後のレジスタ名待ち。
 */
export type Awaiting =
  | "g"
  | "find-char"
  | "text-object"
  | "register-name"
  | "mark-set"
  | "mark-jump"
  | "macro-record-name"
  | "macro-play-name";

/** オペレータ（`d` 削除 / `c` 変更 / `y` ヤンク）。`>` `<` `gu` `gU` 等は対象外（スコープ外）。 */
export type OperatorKey = "d" | "c" | "y";

/** `f`/`t` のうち、対象文字待ちの間だけ覚えておく種別。 */
export type FindCharVariant = "f" | "t";

/** `i`/`a` のうち、テキストオブジェクトの対象文字待ちの間だけ覚えておく種別。 */
export type TextObjectPrefix = "i" | "a";

export interface PendingCommand {
  readonly count: number | null;
  readonly operator: OperatorKey | null;
  /** オペレータキーを押した時点で確定していたcount（モーション側のcountと合成する）。 */
  readonly operatorCount: number | null;
  readonly awaiting: Awaiting | null;
  /** awaiting==='find-char' のときの `f`/`t` の種別。 */
  readonly findVariant: FindCharVariant | null;
  /** awaiting==='text-object' のときの `i`/`a` の種別。 */
  readonly textObjectPrefix: TextObjectPrefix | null;
  /** `"a` で指定された名前付きレジスタ。未指定ならnull（無名レジスタを使う）。 */
  readonly register: string | null;
  readonly rawKeys: readonly Keystroke[];
}

export const EMPTY_PENDING: PendingCommand = {
  count: null,
  operator: null,
  operatorCount: null,
  awaiting: null,
  findVariant: null,
  textObjectPrefix: null,
  register: null,
  rawKeys: [],
};
